import axios from "axios";


const authAxios = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    headers: {"Content-Type": "application/json", "Accept": "application/json"}

})


/* JWT auth, installed once at module load so every authAxios request is
   covered no matter which components are mounted (mobile has no Sidebar).
   Components never install interceptors. */

// One in-flight refresh, shared by every request that 401s at the same time.
let refreshing = null;

const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    window.location.assign("/login");
};

authAxios.interceptors.request.use(config => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
});

authAxios.interceptors.response.use(response => response, async error => {
    if (error.response?.status !== 401) return Promise.reject(error);

    const config = error.config;

    // Still refused after a fresh token — give up.
    if (config._retry) {
        logout();
        return Promise.reject(error);
    }
    config._retry = true;

    try {
        if (!refreshing) {
            // Global axios, as Login uses: no Bearer header on the refresh
            // call, and it never comes back through this interceptor.
            refreshing = axios.post("/token/refresh/", { refresh: localStorage.getItem("refreshToken") })
                .then(res => localStorage.setItem("accessToken", res.data.access))
                .finally(() => { refreshing = null; });
        }
        await refreshing;
    } catch {
        logout();
        return Promise.reject(error);
    }

    config.headers.Authorization = `Bearer ${localStorage.getItem("accessToken")}`;
    return authAxios(config);
});


export default authAxios;
